import React, { useEffect,  } from 'react';
import { useConfigContext } from '../functions/ConfigContext';
import {
  Button,
} from '@mui/material';

import PublicAppBar from '../components/PublicAppBar';

const PublicLanding = ({ }) => {
    const { configLibrary } = useConfigContext();

    useEffect(() => {
        document.title = 'YTrac :: Home';
    }, []); // Empty dependency array to set the title only on mount

    const backgroundImageUrl = '/images/Y-Trac-Landing-Page-Designs.png';

    const goToLoginSelection = () => {
        window.location.replace(configLibrary.b2cUrl);
    };

    return (
        <>
            <PublicAppBar />
            <div style={{ height: '100%' }}>
                <div className='publicLandingContainer'>
                    <div className='right-area'>
                        <Button
                            name="btnLoginTo"
                            color="ywButtonBlue"
                            variant='contained'
                            className='yt-siteselect-action-button '
                            onClick={goToLoginSelection}
                            sx={{
                                height: '42px',
                                width: '250px',
                                borderRadius: '4px',
                            }}
                        >
                            <div className="row-Items-Centered">
                                <img src='/images/YoungWilliams-Icon-White.png' alt="Logo" style={{ width: 25, height: 25 }} />
                                <span className='text-Roboto-S20'>LOG IN TO Y-TRAC</span>
                            </div>
                        </Button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PublicLanding;